import React from 'react'
import { Calendar, Col, Row, Badge } from 'antd'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import styled from 'styled-components'
import moment from 'moment'

const MiniDateCal = styled(Calendar)`
  .ant-picker-content {
    border-collapse: inherit !important;
  }
  .ant-picker-calendar-mini .ant-picker-content th {
    padding: 10 !important;
  }
  td {
    border: 0px !important;
  }
  .ant-picker-cell {
    padding: 10px 0 !important;
    position: relative;
  }
  .ant-picker-cell-in-view {
    color: #4d566e !important;
  }
  .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner,
  .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner,
  .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner {
    height: 35px !important;
    width: 35px !important;
    border-radius: 50% !important;
    justify-content: center !important;
    padding-top: 5px !important;
  }
  .ant-picker-cell-in-view.ant-picker-cell-today
    .ant-picker-cell-inner::before {
    border: 0px !important;
  }
`
const LeftCol = styled(Col)`
  padding-left: 20px;
`
const CenterCol = styled(Col)`
  text-align: center;
`
const StyledUl = styled.ul`
  list-style-type: none;
  padding: 0 1rem;
  position: absolute;
  transform: translateX(-8px);
`
const onPanelChange = (value, mode) => {}

const CalenderStyled = ({
  fullscreen = false,
  setSelected,
  drivesList,
  calendarValue = moment(),
  setDate,
}) => {
  const getListData = date => {
    let listdate = []
    drivesList?.list?.map((item, index) => {
      if (date === moment(item?.drive?.startDate).format('DD/MM/YYYY')) {
        listdate.push(moment(item?.drive?.startDate).format('DD/MM/YYYY'))
      }
    })

    if (listdate?.length === 0) {
      return undefined
    } else {
      return listdate
    }
  }
  const dateCellRender = value => {
    const listData = getListData(value.format('DD/MM/YYYY'))
    return listData ? (
      <StyledUl>
        <li>
          <Badge status="error" />
        </li>
      </StyledUl>
    ) : null
  }
  const dateChange = date => {
    setDate(date.format('YYYY/MM/DD'))
  }
  const monthChange = month => {}

  return (
    <Row>
      <Col span={24}>
        <MiniDateCal
          fullscreen={fullscreen}
          dateCellRender={dateCellRender}
          onSelect={dateChange}
          onChange={monthChange}
          headerRender={({
            value = calendarValue,
            type,
            onChange,
            onTypeChange,
          }) => {

            const current = value.clone()
            const localeData = value.localeData()
            const months = []
            for (let i = 0; i < 12; i++) {
              current.month(i)
              months.push(localeData.months(current))
            }

            const month = value.month()
            setSelected(value.unix())
            const year = value.year()
            return (
              <div>
                <Row type="flex" justify="space-between">
                  <LeftCol span={4}>
                    <LeftArrow
                      onClick={() => {
                        const newValue = value.clone()
                        newValue.month(month - 1)
                        onChange(newValue)
                      }}
                    />
                  </LeftCol>
                  <CenterCol span={16}>
                    <b>
                      {' '}
                      {months[month]} ,{year}
                    </b>

                    <p />
                  </CenterCol>

                  <Col span={4}>
                    <RightArrow
                      onClick={() => {
                        const newValue = value.clone()
                        newValue.month(month + 1)
                        onChange(newValue)
                      }}
                    />
                  </Col>
                </Row>
              </div>
            )
          }}
          onPanelChange={onPanelChange}
        />
      </Col>
    </Row>
  )
}

const RightArrow = styled(RightOutlined)`
  cursor: pointer;
`

const LeftArrow = styled(LeftOutlined)`
  cursor: pointer;
`

export default CalenderStyled
